import AuthenticationLayout from "./AuthenticationLayout";

export default AuthenticationLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/AuthenticationLayout/index.tsx